// extracted by mini-css-extract-plugin
module.exports = {"root":"SenderManagement_root__2Ny8N","section":"SenderManagement_section__2L3N5","sectionLabel":"SenderManagement_sectionLabel__lcENK","loader":"SenderManagement_loader__1X9pk"};